import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-task-posted-by-me',
  templateUrl: './task-posted-by-me.component.html',
  styleUrls: ['./task-posted-by-me.component.css']
})
export class TaskPostedByMeComponent implements OnInit {

  i: any;
  deleteId: any;
  id: any;
  task:any = []
  tagUsersdropdownList  = [];
  tagUsersselectedItems:any = [];
  tagUsersdropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  usersList: any= []
  assignInput = ""
  addClassType = ""
  statusNote = false;
  statusNoteText = ""
  userIdList = [];
  taskType = "All"

  taskMasters:any = []
  ticketId = ''
  TicketData: any = []

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  modelSubtitle = false
  fileType:any;
  file = '';
  tasks:any = []
  images:any= [];
  videos:any= [];
  audios:any= [];
  name = ""
  description = ""
  assignedTo = ""
  searchFilter = ''
  taskId = ""
  note = ""
  taskStatus = ""

  NEW_tasksCount = 0
  ASSIGNED_tasksCount = 0
  REASSIGNED_tasksCount = 0
  WORK_IN_PROGRESS_tasksCount = 0
  PENDING_tasksCount = 0
  COMPLETED_tasksCount = 0
  DEFERRED_tasksCount = 0
  PARTIALLY_COMPLETED_tasksCount = 0
  FORCE_CLOSED_tasksCount = 0
  CLOSED_tasksCount = 0
  Total_tasksCount = 0

  taskPercentage = ""
  cid: any

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getUsers()
    this.getAllByCreatedBy(this.pageNumber,this.recordsPerPage)
    this.form = this.fb.group({
      name: [''],
      description: [''],
      assignedTo: [''],
      tagUserIds: [''],
      taskExpStartDate: [''],
      taskExpEndDate: [''],
    });
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllByCreatedBy(this.pageNumber,this.recordsPerPage)
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
        this.tagUsersdropdownList = res.response;
        console.log(res);
      }
    )
  }

  addTask(){
    let tagUserIds = [];
    for(let i = 0; i < this.tagUsersselectedItems.length; i++) {
      tagUserIds.push(Number(this.tagUsersselectedItems[i].userId))
    }
    let status = ''
    if(this.form.get('assignedTo').value == ''){
      status = "NEW"
    }else{
      status = "ASSIGNED"
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "taskRegType": "string",
      "taskRegId": "string",
      "taskSINumber": 0,
      "taskListingNumber": 0,
      "assignedTo": String(this.form.get('assignedTo').value),
      "taskExpStartDate": new Date(this.form.get('taskExpStartDate').value).getTime(),
      "taskExpEndDate": new Date(this.form.get('taskExpEndDate').value).getTime(),
      "taskActStartDate": 0,
      "taskActEndDate": 0,
      "taskExpDuration": 0,
      "taskActDuration": 0,
      "status": [
        {
          "note": "string",
          "taskStatus": status,
          "updatedDate": 0
        }
      ],
      "completedPercentage": 0,
      "notes": "string",
      "audio": this.audios,
      "video": this.videos,
      "image": this.images,
      "tagUserIds": tagUserIds,
      "name": String(this.form.get('name').value),
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.addTask(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllByCreatedBy(this.pageNumber,this.recordsPerPage)
        this.clearForm()
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllByCreatedBy(pageNumber:any,recordsPerPage:any){
    this.isLoading = true;

    this.taskType = "All"
    this.generic_service.getAllByCreatedBy(pageNumber,recordsPerPage,sessionStorage.getItem('userId')).subscribe(
      (response:any)=>{
        this.tasks = response.response.taskList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false;
      }
    )
  }

  onSelectFile(event:any){
    if(event.target.files){
      console.log(event.target.files[0].type)
      console.log(event.target.files[0])
      if(event.target.files[0].type == "image/jpeg" || event.target.files[0].type == "image/png" || event.target.files[0].type == "image/png"){
        console.log('image')
        this.fileType = 'image'
      }else if(event.target.files[0].type == "video/mp4"){
        console.log('video')
        this.fileType = 'video'
      }else if(event.target.files[0].type == "audio/mpeg"){
        console.log('audio')
        this.fileType = 'audio'
      }
      var reader = new FileReader;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload=(e:any)=>{
        this.file=e.target.result;
        if(this.fileType == 'image'){
          this.images.push(this.file)
        }
        if(this.fileType == 'video'){
          this.videos.push(this.file)
        }
        if(this.fileType == 'audio'){
          let file = URL.createObjectURL(event.target.files[0])
          this.audios.push(file)
        }
      }
    }
  }

  addImageBtn(){
    document.getElementById("add-image-btn")?.click()
  }

  addVideoBtn(){
    document.getElementById("add-video-btn")?.click()
  }

  addAudioBtn(){
    document.getElementById("add-audio-btn")?.click()
  }

  editskill(){
    this.tasks[this.i].name=this.name
    this.tasks[this.i].description=this.description
    this.tasks[this.i].assignedTo = this.assignedTo;
    this.close()
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.description = ""
    this.assignedTo = ""
  }
  
  edit(i:any){
    this.open();
  }

  deleteTask(){
    this.generic_service.delTask(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success(res.message);
        this.getAllByCreatedBy(this.pageNumber,this.recordsPerPage)
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);         
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  statusDropdown(){
    if(this.task[0].assignedTo == '' || this.task[0].assignedTo == null){
      this.addClass('assignedTo')
    }else{
      if(this.statusNote == true){
        this.statusNote = false;
      }else{
        this.statusNote = true;
      }
    }

  }
  taskAssignToUser(taskId:any, userId: any,taskStatus:any,name:string){
    let note = "";
    // if(taskStatus == "REASSIGNED"){
    //   note = "Task ASSIGNED to " + name;
    // }
    note = "Task ASSIGNED to " + name;
    let body = {
      "taskId": Number(taskId),
      "userId": Number(userId),
      "taskStatusDTO": {
        "note": String(note),
        "taskStatus": String(taskStatus),
        "updatedDate": 0
      }
    }
    console.log(body)
    this.generic_service.taskAssignToUser(body).subscribe(
      (response:any)=>{
        console.log(response);
        this.addClass('assignedTo')
        this.getSingleTask(taskId);
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }
  updateStatus(taskId:any,){
    let body = {
      "note": String(this.note),
      "taskStatus": String(this.taskStatus),
      "updatedDate": 0
    }
    console.log(body);
    this.generic_service.updateStatus(body,taskId).subscribe(
      (response:any)=>{
        this.statusNote = false;
        this.getSingleTask(taskId);
        this.note = ''
        this.taskStatus = ""
        console.log(response)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  addClass(value:any){
    console.log(value)
    if(this.addClassType == ''){
      let list = document.getElementById('assign-and-tag-data')
      if(list?.classList.contains('assign-show')){
        list.classList.remove('assign-show')
        this.addClassType = ''
      }else{
        list?.classList.add('assign-show')
        this.addClassType = value
      }
    }else{
      if(this.addClassType == value){
        let list = document.getElementById('assign-and-tag-data')
        if(list?.classList.contains('assign-show')){
          list.classList.remove('assign-show')
          this.addClassType = ''
        }else{
          list?.classList.add('assign-show')
          this.addClassType = value
        }
      }else{
        this.addClassType = value
      }
    }
  }

  getTasksByStatus(status:any){
    this.taskType = status;
    this.addClassType = '';
    console.log(status)
    this.generic_service.getTasksByStatus(this.pageNumber,this.recordsPerPage,status).subscribe(
      (res:any)=>{
        console.log(res)
        this.tasks = res.response.taskList;
        this.totalRecords = res.response.totalRecords;
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  // getTaskTypeCount(){
  //   this.generic_service.getAllTask().subscribe(
  //     (response:any)=>{
  //       let NEW = 0
  //       let ASSIGNED = 0
  //       let REASSIGNED = 0
  //       let WORK_IN_PROGRESS = 0
  //       let PENDING = 0
  //       let COMPLETED = 0
  //       let DEFERRED = 0
  //       let PARTIALLY_COMPLETED = 0
  //       let FORCE_CLOSED = 0
  //       let CLOSED = 0
  //       this.Total_tasksCount = response.response.length
  //       for(var i=0; i<response.response.length; i++) {
  //         if(response.response[i].latestStatus == 'NEW'){
  //           NEW++;
  //         }
  //         if(response.response[i].latestStatus == 'ASSIGNED'){
  //           ASSIGNED++;
  //         }
  //         if(response.response[i].latestStatus == 'REASSIGNED'){
  //           REASSIGNED++;
  //         }
  //         if(response.response[i].latestStatus == 'WORK_IN_PROGRESS'){
  //           WORK_IN_PROGRESS++;
  //         }
  //         if(response.response[i].latestStatus == 'PENDING'){
  //           PENDING++;
  //         }
  //         if(response.response[i].latestStatus == 'COMPLETED'){
  //           COMPLETED++;
  //         }
  //         if(response.response[i].latestStatus == 'DEFERRED'){
  //           DEFERRED++;
  //         }
  //         if(response.response[i].latestStatus == 'PARTIALLY_COMPLETED'){
  //           PARTIALLY_COMPLETED++;
  //         }
  //         if(response.response[i].latestStatus == 'FORCE_CLOSED'){
  //           FORCE_CLOSED++;
  //         }
  //         if(response.response[i].latestStatus == 'CLOSED'){
  //           CLOSED++;
  //         }
  //       }
  //       console.log(response)
  //       this.NEW_tasksCount = NEW
  //       this.ASSIGNED_tasksCount = ASSIGNED
  //       this.REASSIGNED_tasksCount = REASSIGNED
  //       this.WORK_IN_PROGRESS_tasksCount = WORK_IN_PROGRESS
  //       this.PENDING_tasksCount = PENDING
  //       this.COMPLETED_tasksCount = COMPLETED
  //       this.DEFERRED_tasksCount = DEFERRED
  //       this.PARTIALLY_COMPLETED_tasksCount = PARTIALLY_COMPLETED
  //       this.FORCE_CLOSED_tasksCount = FORCE_CLOSED
  //       this.CLOSED_tasksCount = CLOSED
  //     }
  //   )
  // }

  getSingleTask(id:any){
    console.log(id)
    this.generic_service.getSingleTask(id).subscribe(
      (res:any)=>{
        this.task = [];
        console.log(res);
        this.ticketId = res.response.ticketId
        this.taskId = res.response.id;
        this.task.push(res.response);
        if(this.ticketId != null && this.ticketId != null){
          this.getSingleTicket(this.ticketId)
        }
        let arr:any = [];
        arr.push(Number(sessionStorage.getItem('userId')))
        let arr1:any = [];
        if(res.response.assignedTo != null && res.response.assignedTo != 0){
          arr1.push(res.response.assignedTo)
        }
        if(res.response.tagUsers.length != 0){
          for(let j=0; j<res.response.tagUsers.length; j++){
            arr.push(res.response.tagUsers[j].userid)
          }
        }
        let arr3 = arr.concat(arr1)
        this.userIdList = arr3
        this.userIdList = this.userIdList.filter((item,index) => this.userIdList.indexOf(item) === index);;
        console.log(this.userIdList)
      }
    )
  }


  insertConversation(){
    let body =  {
      "version": 0,
      "isActive": true,
      "description": "string",
      "id": 0,
      "conversationType": "TASK",
      "ticketTaskId": Number(this.taskId),
      "userIdList": this.userIdList,
      "remarks": "string",
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.insertConversation(body).subscribe(
      (response:any)=> {
        console.log(response)
        this.toastr.success(response.message)
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
      }
    )
  }

  taskStatusDropdown(){
    console.log(this.taskStatus)

    if(this.taskStatus == "WORK_IN_PROGRESS"){
      this.note = "Started working on this"
    }
    if(this.taskStatus == "COMPLETED"){
      this.note = "Complteed the task"
    }
    if(this.taskStatus == "PENDING"){
      this.note = "Moving to Pending"
    }
    if(this.taskStatus == "DEFERRED"){
      this.note = "Moving to deffered"
    }
    if(this.taskStatus == "PARTIALLY_COMPLETED"){
      this.note = "Partially completed the task"
    }
    if(this.taskStatus == "FORCE_CLOSED"){
      this.note = "Closing the task due to"
    }
    if(this.taskStatus == "CLOSED"){
      this.note = "Task Closed"
    }

  }

  updateTaskPercentage(percentage:any,taskId:any){
    if(this.taskPercentage != percentage){
      console.log(percentage)
      let body = {
        "taskId": Number(taskId),
        "taskPercentage": Number(percentage)
      }
      this.generic_service.updateTaskPercentage(body).subscribe(
        (response:any)=>{
          console.log(response);
          this.getSingleTask(taskId)
        },
        (error:any)=>{
          console.log(error)
        }
      )
    }
  }

  TaskPercentage(percentage:any){
    this.taskPercentage = percentage
    console.log(this.taskPercentage)
  }

  clearForm(){
    this.tagUsersselectedItems = []
    this.images = [];
    this.videos = [];
    this.audios = [];
    this.form.reset()
  }

  searchclear(){
    this.searchFilter = ""
    this.getAllByCreatedBy(this.pageNumber,this.recordsPerPage)
  }

  taskFilterByWildSearch(searchKey:any){
    console.log(searchKey)
    console.log(searchKey.length)

    if(searchKey == ""){
      this.getAllByCreatedBy(this.pageNumber,this.recordsPerPage)
    }else{
      this.generic_service.taskFilterByWildSearch(searchKey).subscribe(
        (response:any)=>{
          console.log(response)
          this.tasks = response.response;
        },
        (error:any)=>{
          console.log(error)
        }
      )
    }
  }
  getSingleTicket(id:any){
    console.log(id)
    this.TicketData = []
    this.generic_service.getSingleTicket(id).subscribe(
      (res:any)=>{
        this.TicketData = [];
        this.TicketData.push(res.response.ticket);
      }
    )
  }

}
